import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import StoreAppPushRange from '@/types/table/storeAppPushRange';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface StoreAppPushRangeData extends StoreAppPushRange {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class StoreAppPushRangeController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<StoreAppPushRangeData>>(API_CONTEXT + '/app/storeAppPushRange/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<StoreAppPushRangeData>(API_CONTEXT + '/app/storeAppPushRange/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/storeAppPushRange/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/storeAppPushRange/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/storeAppPushRange/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/storeAppPushRange/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/storeAppPushRange/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/storeAppPushRange/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/storeAppPushRange/deleteBatch', params, httpOptions);
  }
}
